module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2020-09-04 at 22.35.38.4e02e4c3.jpeg";